import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useI18n } from "@/lib/i18n";
import SEOHead from "@/components/SEOHead";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import AboutVideo from "@/components/AboutVideo";
import VenuePresentation from "@/components/VenuePresentation";
import UpcomingEvents from "@/components/UpcomingEvents";
import GastronomySection from "@/components/GastronomySection";
import AvailabilityCalendar from "@/components/AvailabilityCalendar";
import TariffSection from "@/components/TariffSection";
import LayoutConfigurations from "@/components/LayoutConfigurations";
import Gallery from "@/components/Gallery";
import OffsiteSection from "@/components/OffsiteSection";
import ContactSection from "@/components/ContactSection";
import LocationMap from "@/components/LocationMap";
import Footer from "@/components/Footer";
import WhatsAppFloat from "@/components/WhatsAppFloat";
import { api } from "@/lib/api";

export default function LandingPage() {
  const [config, setConfig] = useState({ whatsapp_number: "34638382033" });

  useEffect(() => {
    api.get("/config").then((r) => setConfig(r.data)).catch(() => {});
  }, []);

  // Restore scroll position when coming back from an event detail page
  useEffect(() => {
    try {
      const saved = sessionStorage.getItem("aura.homeScroll");
      if (saved !== null) {
        const y = parseInt(saved, 10);
        sessionStorage.removeItem("aura.homeScroll");
        // Wait for sections to mount + images to render before restoring
        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(() => {
            window.scrollTo({ top: y, behavior: "instant" in window ? "instant" : "auto" });
          });
        });
      }
    } catch { /* ignore */ }
    const hash = window.location.hash;
    if (hash.length > 1) {
      setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 500);
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#fdfcf9] text-[#2A2421]" data-testid="landing-page">
      <SEOHead />
      <Navbar />
      <Hero />
      <AboutVideo />
      <VenuePresentation />
      <UpcomingEvents />
      <GastronomySection />
      <AvailabilityCalendar whatsappNumber={config.whatsapp_number} />
      <TariffSection whatsappNumber={config.whatsapp_number} />
      <LayoutConfigurations />
      <OffsiteSection />
      <Gallery />
      <ContactSection whatsappNumber={config.whatsapp_number} />
      <LocationMap />
      <Footer />
      <WhatsAppFloat number={config.whatsapp_number} />
    </div>
  );
}
